export default __webpack_public_path__ + "static/media/view-icon.07cfdaa1.svg";